module.exports = __webpack_public_path__ + "img/00_bg_02.3872571d.png";